import { render, staticRenderFns } from "./InstallPlugin.vue?vue&type=template&id=46cd13a2"
import script from "./InstallPlugin.vue?vue&type=script&lang=js"
export * from "./InstallPlugin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports